import { useEffect, useState } from 'react'

export const useScrollableTabs = (
  tabListRef: React.RefObject<HTMLDivElement>,
  scrollable: boolean
) => {
  const [isContentOverflowing, setIsContentOverflowing] = useState(false)

  useEffect(() => {
    if (!scrollable || !tabListRef.current) return

    const calculate = () => {
      if (tabListRef.current) {
        const wrapperWidth = tabListRef.current.getBoundingClientRect().width
        setIsContentOverflowing(tabListRef.current.scrollWidth > wrapperWidth)
      }
    }

    calculate()

    const resizeObserver = new ResizeObserver(calculate)
    resizeObserver.observe(tabListRef.current)

    const mutationObserver = new MutationObserver(calculate)
    mutationObserver.observe(tabListRef.current, {
      childList: true,
      subtree: true,
    })

    return () => {
      resizeObserver.disconnect()
      mutationObserver.disconnect()
    }
  }, [scrollable, tabListRef])

  return { isContentOverflowing }
}
